import { upperFirst } from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'

import KpiMap from 'src/commons/graphs/KpiMap'
import { IFeature } from 'src/commons/types'

interface IProps {
  data?: {
    features: IFeature[]
    type: string
  }
  title?: string
}

function DeploymentMap(props: IProps) {
  const { t } = useTranslation()
  const legend = upperFirst(t('kpi.DeployedMap.legend_area'))
  const tooltipLegend = upperFirst(t('kpi.DeployedMap.legend_map'))
  return <KpiMap title={props.title} data={props.data} legend={legend} tooltipLegend={tooltipLegend} />
}

export default DeploymentMap
